/* eslint react/no-string-refs: "off" */

import React from 'react';
import _ from 'lodash';

import Tippy from './ReactTippy';
import fetchMg from '../utilities/fetchManager';
import {
  HEAD_OFFICE_OPTION,
  PartnerCompanyBranchDropdown,
} from './PartnerCompanyBranchDropdown';
import MultiSelectDropdownSaveOnClose from './dropdowns/MultiSelectDropdownSaveOnClose';
import {
  roleIdToJapaneseRoleName,
  isTargetRoleId,
} from '../utilities/roleUtility';
import dialogLoader from '../utilities/dialogLoader';
import { USER_ROLES, CALL_FROM_PAGE } from '../utilities/constants';
import { isPartnerRoleId } from '../utilities/roleUtility';
import { FieldTreeWorkerManagerBase } from './FieldTreeWorkerManagerBase';
import SessionStorageService from '../services/utilities/SessionStorageService';
import { messageUtility } from '../utilities/messageUtility';
import { NotLoginForemanWarningDialog } from './modals/NotLoginForemanWarningDialog';
import { JobService } from '../services/Jobs';
import { Information } from '../components/modals/common/';
import { BuildeeManagerIcon } from '../components/icons/BuildeeManagerIcon';
import InfinityScrollLoad from '../components/InfinityScrollLoad';
import * as dialog from '../components/FieldTreeDialog';

const REGISTABLE_LIST_LIMIT = 300;

/**
 * 協力会社作業員追加
 */
export default class FieldTreeAdminWorkerManager extends FieldTreeWorkerManagerBase {
  constructor(props) {
    super(props);

    this.postflag = true;
    this.submitUpdatingFlag = false;
    this.submitConnectUpdatingFlag = false;

    // 自社の会社ID
    this.myCompanyId = parseInt(SessionStorageService.getCompanyId(), 10);

    this.refineTableRightSide = React.createRef();
  }

  loadWorker = async (param = {}) => {
    const { partner_company_branch_id: branchId } = param;
    if (branchId) {
      if (branchId === HEAD_OFFICE_OPTION.id) {
        param.partner_company_branch_id = null;
      }
    } else {
      delete param.partner_company_branch_id;
    }

    if (_.isArray(this.state.worker) && param.isScroll) {
      param.offset = this.state.offsetSize;
      if (param.offset > this.state.workerTotal) {
        param.offset = this.state.workerTotal;
      }
    } else {
      param.offset = 0;
    }

    if (!param.limit) {
      param.limit = REGISTABLE_LIST_LIMIT;
    }

    /**
     * 登録可能作業員
     */
    //https://v2-dev.buildee.jp/apidocs/public/field_tree_users/registable_list.html
    ///api/private/fields/:field_id/field_trees/field_tree_id/field_tree_users/registable_list
    const data = await fetchMg
      .GetAjax(
        `/api/private/fields/${this.state.field_id}/field_trees/${
          this.state.field_tree_id
        }/field_tree_users/registable_list`,
        param
      )
      .catch(error => {
        this.stopScroll(param);
        if (!_.isEmpty(error)) {
          this.setState({ partnerCompanyBranchId: '' });
          this.showErrorDialog(error[0].responseJSON.message);
        }
      });
    if (data && data.result) {
      // アカウントが停止されてる場合表示しない
      let workers = data.data.entities.user_lists;
      const thisOffsetSize = _.size(workers);
      workers = _.filter(workers, (itemA) => {
        // 右側に移したユーザーは除く
        return !_.some(this.state.assignedWorker || [], (itemB) => itemA.id === itemB.id);
      });
      const activeWorkers = this.activeWorkers(workers);
      let loadedWorkers;
      let isLoaded;
      if (param.isScroll) {
        loadedWorkers = this.loadedWorkers(activeWorkers);
        isLoaded = param.offset === this.state.workerTotal || param.offset === this.state.offset || _.isUndefined(workers);
      } else {
        loadedWorkers = activeWorkers;
        isLoaded = false;
      }

      this.setState((prevState) => ({
        ...prevState,
        worker: loadedWorkers,
        workerTotal: data.data.total,
        offsetSize: param.isScroll ? ((prevState.offsetSize || 0) + thisOffsetSize) : thisOffsetSize,
        offset: param.offset,
        isLoaded,
      }));
    } else {
      this.stopScroll(param);
    }
  };

  /**
   * 登録可能ユーザー
   * @param {array} workers 抽出したユーザー
   * @return {array} 登録可能ユーザー
   */
  activeWorkers = (workers) => {
    const activeWorkers = _.filter(workers, worker => {
      return worker.block_flag === 0;
    });
    return activeWorkers;
  }

  /**
   * 読み込み済みのリスト
   * 読み込み済みのリストに抽出したユーザーをユニークに追加して返す
   * @param {array} activeWorkers 登録可能ユーザー
   * @return {array} 読み込み済みのリスト
   */
  loadedWorkers = (activeWorkers) => {
    const state = _.cloneDeep(this.state);
    const targetWorkers = state.worker;
    return _.uniqWith(_.concat(targetWorkers, activeWorkers), (arrVal, othVal) => { return arrVal.id === othVal.id; });
  }

  searchUser = e => {
    const { value } = e.target;
    const { partnerCompanyBranchId } = this.state;

    clearTimeout(this.inputTimer);
    this.inputTimer = setTimeout(() => {
      this.loadWorker({
        name: value,
        partner_company_branch_id: partnerCompanyBranchId,
      });
    }, 500);

    this.setState({ searchName: value });
  };

  /**
   * 登録済みの作業員を名前で絞り込む
   *
   */
  refineAssignedUser = () => {
    this.clearCheckedAssignedWorker();
    this.forceUpdate();
  };

  /**
   * ユーザーリストをスクロールする
   * @param {function} notify スクロールの終了通知
   */
  async scrollWorker(notify) {
    const state = _.cloneDeep(this.state);
    if (state.isLoaded && notify) {
      notify();
      return;
    }
    await this.loadWorker({
      partner_company_branch_id: state.partnerCompanyBranchId,
      name: state.searchName,
      isScroll: true,
    });
    if (notify) {
      notify();
    }
  }

  /**
   * スクロールを終了する
   * @param {object} param APIに渡したパラメータ
   */
  stopScroll = (param) => {
    if (!param.isScroll) {
      return;
    }
    const state = _.cloneDeep(this.state);
    state.isLoaded = true;
    this.setState(state);
  };

  /**
   * 未登録ユーザー
   */
  Workers() {
    const style = {
      fontSize: '12px',
      color: '#7C7C7C',
      padding: '8px',
      textAlign: 'center',
    };

    if (!_.size(this.state.worker)) {
      return (
        <tr onClick={this.selectRow} className='table__item'>
          <td className='value-table'>
            <div style={style}>{messageUtility.getMessage('E-001-002')}</div>
          </td>
        </tr>
      );
    }

    return _.map(this.state.worker, worker => {
      return (
        <Worker
          key={JSON.stringify(worker.id + worker.updated_at)}
          data={worker}
          callback={this.pushCheckedWorker}
        />
      );
    });
  }

  /**
   * チェック
   */
  pushCheckedWorker = (id, checked) => {
    const worker = _.map(this.state.worker, item => {
      if (item.id == id) {
        item['checked'] = checked;
      }
      return item;
    });
    this.setState({ worker });
  };

  /**
   * チェックボックスをクリア
   */
  clearCheckedAssignedWorker = () => {
    const newAssignedWorker = _.cloneDeep(this.state.assignedWorker);
    _.each(newAssignedWorker, item => {
      item['checked'] = false;
    });
    this.setState({ assignedWorker: newAssignedWorker });
  };

  /**
   * 登録済みユーザー
   */
  AssignedWorkers() {
    const value = this.refs.refineName ? this.refs.refineName.value : null;
    const { localPartnerCompanyBranchId: branchId } = this.state;
    let result = { ...this.state.assignedWorker };

    if ((!branchId || branchId === 'empty') && !value) {
      return _.map(result, worker => {
        return (
          <AssignedWorker
            checkWorker={this.validateWorker}
            key={JSON.stringify(worker.id + worker.updated_at)}
            fieldTreeId={this.state.field_tree_id}
            data={worker}
            callback={this.PushCheckedAssignWorker}
            callbackJobs={this.UpdateAssignWorkerJob}
            refineTableRightSide={this.refineTableRightSide.current}
          />
        );
      });
    }

    if (branchId && branchId !== 'empty') {
      result = _.filter(result, worker => {
        if (branchId !== HEAD_OFFICE_OPTION.id) {
          return (
            worker.partner_company_branch &&
            String(worker.partner_company_branch.id) === String(branchId) &&
            (worker.fullname.includes(value) ||
              worker.fullname_kana.includes(value))
          );
        } else {
          return (
            worker.partner_company_branch === null &&
            (worker.fullname.includes(value) ||
              worker.fullname_kana.includes(value))
          );
        }
      });
    }

    if (value) {
      result = _.filter(result, worker => {
        return (
          worker.fullname.includes(value) ||
          worker.fullname_kana.includes(value)
        );
      });
    }

    return _.map(result, worker => {
      return (
        <AssignedWorker
          key={JSON.stringify(worker.id + worker.updated_at)}
          data={worker}
          callback={this.PushCheckedAssignWorker}
          callbackJobs={this.UpdateAssignWorkerJob}
          refineTableRightSide={this.refineTableRightSide.current}
        />
      );
    });
  }

  /**
   * 登録予定ユーザーチェック
   * @param {int} id
   * @param {int} checked
   */
  PushCheckedAssignWorker = (id, checked) => {
    let _worker = _.cloneDeep(this.state.assignedWorker);
    _worker = _.map(_worker, worker => {
      if (worker.id == id) {
        worker['checked'] = checked;
      }
      return worker;
    });
    this.setState({ assignedWorker: _worker });
  };

  /**
   * 登録予定ユーザーの職種
   * @param {int} id
   * @param {array} jobs
   */
  UpdateAssignWorkerJob = (id, jobs) => {
    let _worker = _.cloneDeep(this.state.assignedWorker);
    _worker = _.map(_worker, worker => {
      if (worker.id == id) {
        worker.jobs = jobs;
      }
      return worker;
    });
    this.setState({ assignedWorker: _worker });
  };

  validateWorker = () => {
    let param = {
      users: _.map(this.state.assignedWorker, worker => {
        return { id: worker.id, job_ids: worker.jobs };
      }),
    };
    if (!param.users.length) {
      return;
    }

    this.validate = true;
    _.each(param.users, p => {
      if (!p.job_ids) {
        this.validate = false;
      }
    });
    this.setState({ validate: this.validate });
  };

  /**
   * 一人も選んでないときにボタン押させない
   *
   * @returns
   * @memberof FieldTreeAdminWorkerManager
   */
  canNotSubmit() {
    return _.size(this.state.assignedWorker) === 0;
  }

  /**
   * 登録ボタンの押下
   *
   * @returns
   * @memberof FieldTreeAdminWorkerManager
   */
  submit = async () => {
    // 多重更新防止
    if (this.submitUpdatingFlag === true) {
      return;
    }
    this.submitUpdatingFlag = true;

    // 一人も選んでないときはAPI叩けないため
    if (this.canNotSubmit()) {
      this.submitUpdatingFlag = false;
      return;
    }

    // trueなら正しい
    this.validate = true;
    // 職業のプルダウン確認
    _.each(this.state.assignedWorker, paramUser => {
      // 協力会社管理者ユーザー以外(職長の場合)は、職種が未選択の場合エラー
      if (
        !isPartnerRoleId(paramUser.user_role_code) &&
        (_.isUndefined(paramUser.jobs) || _.isEmpty(paramUser.jobs))
      ) {
        this.validate = false;
      }
    });

    this.setState({ validate: this.validate });
    if (!this.validate) {
      this.submitUpdatingFlag = false;
      return;
    }

    // api :GET, '/api/private/users/login_check', 'ログインチェックAPI'
    let loginCheckParams = {
      // user_id の配列
      user_ids: _.map(this.state.assignedWorker, worker => {
        return worker.id;
      }),
    };

    const checkResult = await fetchMg
      .GetAjax('/api/private/users/login_check', loginCheckParams)
      .catch(() => ({ result: false }));
    // data>entities>users（配列）>user_id:xxx,login:true,user_role:5 のような形になる

    // ダメなユーザー
    const badUsers = checkResult.data.entities.users.flatMap(item =>
      // ログインしてないかつ職長
      item.login === false &&
      isTargetRoleId([USER_ROLES.foreman], item.user_role)
        ? // オブジェクトの配列を作る
          { user_id: item.user_id, user_role: item.user_role }
        : []
    );

    if (badUsers.length > 0) {
      // 警告ダイアログ
      this.setState({ isForemanWarningDialog: true, badUsers });

      // 登録させない
      this.submitUpdatingFlag = false;
      return;
    }

    // 次のAPIを呼ぶ
    if (this.postflag === true) {
      this.submitConnect();
    } else if (this.postflag === false) {
      this.postflag = true;
      this.submitUpdatingFlag = false;
      return;
    }
  };

  /**
   * 本当に現場招待させる
   *
   * @returns
   * @memberof FieldTreeAdminWorkerManager
   */
  submitConnect = async () => {
    // 多重更新防止
    if (this.submitConnectUpdatingFlag) {
      return;
    }
    this.submitConnectUpdatingFlag = true;

    this.setState({ isForemanWarningDialog: false });

    //https://v2-dev.buildee.jp/apidocs/public/field_tree_users/create_list.html
    ///api/private/fields/:field_id/field_trees/:field_tree_id/field_tree_users/list
    const param = {
      users: _.map(this.state.assignedWorker, worker => {
        return { id: worker.id, job_ids: worker.jobs };
      }),
    };

    if (!param.users.length) {
      this.submitConnectUpdatingFlag = false;
      return;
    }

    const data = await fetchMg
      .PostAjax(
        `/api/private/fields/${this.state.field_id}/field_trees/${
          this.state.field_tree_id
        }/field_tree_users/list`,
        param
      )
      .catch(error => ({
        result: false,
        message: error[0].responseJSON.message,
      }));

    this.postflag = false;

    if (data.result) {
      console.log('POST Success :', data.data);
    } else {
      await this.showRegistErrorDialog(data.message);
    }
    this.submitConnectUpdatingFlag = false;

    this.props.dialog.callback.submit(param);
  };

  showRegistErrorDialog = async message => {
    return new Promise(resolve => {
      dialogLoader.show(dialog.submitErrorMessage, {
        title: messageUtility.getMessage('E-000-006'),
        message,
        callback: {
          done: () => {
            resolve(true);
            dialogLoader.close();
          },
        },
      });
    });
  };

  showErrorDialog = errorMessage => {
    this.handleVisibleDialog(true);
    this.setState({ errorMessage });
  };

  handleVisibleDialog = visibleDialogFlag => {
    this.setState({
      visibleDialogFlag,
    });
  };

  handlePartnerCompanyBranchDropdownChange = id => {
    this.setState({ partnerCompanyBranchId: id }, () => {
      const { partnerCompanyBranchId, searchName } = this.state;
      this.loadWorker({
        partner_company_branch_id: partnerCompanyBranchId,
        name: searchName,
      });
    });
  };

  researchAssignedUser = localPartnerCompanyBranchId => {
    this.clearCheckedAssignedWorker();
    this.setState({ localPartnerCompanyBranchId });
  };

  render() {
    const alertStyle = () => {
      return !this.state.validate ? 'alert show' : 'alert';
    };

    return (
      <React.Fragment>
        {/* 元のダイアログはisForemanWarningDialogを使ってdisolayのstyleで隠す */}
        <div
          className='dialog dialog--modal dialog--dialog-worker-manage dialog--admin-worker-manage'
          style={{
            margin: 0,
            display:
              this.state.isForemanWarningDialog !== true ? 'block' : 'none',
            width: '1368px',
            maxWidth: '1368px',
          }}
          hidden={false}
        >
          <div className='dialog__header'>
            <span className='dialog__title'>
              {messageUtility.getMessage('I-001-001')}
            </span>
          </div>
          <div className='dialog__body'>
            <div className='dual-panel'>
              <div className='dual-panel__item'>
                <div className='panel'>
                  <div className='panel-header'>
                    <div className='panel-title'>
                      {this.state.company_name}のユーザー
                    </div>
                    <div className='panel-item'>
                      <div className='panel-item__select'>
                        <div className='panel-item__select-label'>
                          <div className='label'>支店で検索</div>
                        </div>
                        <div className='panel-item__select-element'>
                          <PartnerCompanyBranchDropdown
                            selectedCompanyId={this.state.company_id}
                            selectedPartnerCompanyBranchId={
                              this.state.partnerCompanyBranchId
                            }
                            onSelect={
                              this.handlePartnerCompanyBranchDropdownChange
                            }
                            fixedOptions={[HEAD_OFFICE_OPTION]}
                            params={{
                              call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE,
                            }}
                            isOptional={true}
                            dropdownSelectStyle={{ width: '150px' }}
                          />
                        </div>
                      </div>
                      <div className='panel-item__select'>
                        <div className='panel-item__select-label'>
                          <div className='label'>氏名で検索</div>
                        </div>
                        <div className='panel-item__select-element'>
                          <input
                            type='text'
                            placeholder='ユーザー名'
                            onChange={this.searchUser}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='panel-list worker-manage-table'>
                      <table className='table table--worker-manage-label'>
                        <thead className='table__header'>
                          <tr className='table__label'>
                            <td className='value-table value-table--table__label' />
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-branch'>
                              <div className='admin-worker-manage-table__header-text'>
                                支店
                              </div>
                            </td>
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-user-type'>
                              <div className='admin-worker-manage-table__header-text'>
                                ユーザー種別
                              </div>
                            </td>
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-name'>
                              <div className='admin-worker-manage-table__header-text'>
                                氏名
                              </div>
                            </td>
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-user-id'>
                              <div className='admin-worker-manage-table__header-text'>
                                ID
                              </div>
                            </td>
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-permission'>
                              <div className='admin-worker-manage-table__header-text'>
                                権限
                              </div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                      <div
                        className='worker-manage-table-element'
                        id='worker-manage-left-side-table'
                      >
                        <table className='table'>
                          <tbody>{this.Workers()}</tbody>
                        </table>
                        <InfinityScrollLoad
                          targetId={'worker-manage-left-side-table'}
                          total={_.size(this.state.worker)}
                          no_data_message={' '}
                          callback={notifyEnd => {
                            this.scrollWorker(notifyEnd);
                          }}
                        />
                      </div>
                    </div>
                    <div className='search-form__info'>
                      <div className='search-form__info-text'>
                        ※検索条件で支店を選択してユーザーが見つからない場合、支店を未選択にし氏名のみで再度検索してください。
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='dual-panel__navi'>
                <div className='dual-panel__navi-item'>
                  <button
                    className='btn-move__right'
                    onClick={() => {
                      this.moveToRight(() => {
                        this.loadWorker({
                          partner_company_branch_id: this.state.partnerCompanyBranchId,
                          name: this.state.searchName,
                          isScroll: true,
                        });
                      });
                    }}
                  />
                </div>
                <div className='dual-panel__navi-spacer' />
                <div
                  className='dual-panel__navi-item'
                  onClick={() => {
                    this.moveToLeft();
                  }}
                >
                  <button className='btn-move__left' />
                </div>
              </div>
              <div className='dual-panel__item'>
                <div className='panel'>
                  <div className='panel-header'>
                    <div className='panel-title'>
                      {messageUtility.getMessage('I-001-002')}
                    </div>
                    <div className='panel-item'>
                      <div className='panel-item__select'>
                        <div className='panel-item__select-label'>
                          <div className='label'>支店で検索</div>
                        </div>
                        <div className='panel-item__select-element'>
                          <PartnerCompanyBranchDropdown
                            selectedCompanyId={this.state.company_id}
                            selectedPartnerCompanyBranchId={
                              this.state.localPartnerCompanyBranchId
                            }
                            onSelect={this.researchAssignedUser}
                            fixedOptions={[HEAD_OFFICE_OPTION]}
                            params={{
                              call_from: CALL_FROM_PAGE.FIELD_TREE_PAGE,
                            }}
                            isOptional={true}
                            dropdownSelectStyle={{ width: '150px' }}
                          />
                        </div>
                      </div>
                      <div className='panel-item__select'>
                        <div className='panel-item__select-label'>
                          <div className='label'>氏名で検索</div>
                        </div>
                        <div className='panel-item__select-element'>
                          <input
                            ref='refineName'
                            type='text'
                            placeholder='ユーザー名'
                            onChange={this.refineAssignedUser}
                          />
                        </div>
                      </div>
                    </div>

                    <div className='panel-list worker-manage-table'>
                      <table className='table table--worker-manage-label'>
                        <thead className='table__header'>
                          <tr className='table__label'>
                            <td className='value-table value-table--table__label' />
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-branch'>
                              <div className='admin-worker-manage-table__header-text'>
                                支店
                              </div>
                            </td>
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-job'>
                              <div className='admin-worker-manage-table__header-text'>
                                職種
                              </div>
                            </td>
                            <td className='value-table value-table--table__label  admin-worker-manage-table__header-name'>
                              <div className='admin-worker-manage-table__header-text'>
                                氏名
                              </div>
                            </td>
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-user-id'>
                              <div className='admin-worker-manage-table__header-text'>
                                ID
                              </div>
                            </td>
                            <td className='value-table value-table--table__label admin-worker-manage-table__header admin-worker-manage-table__header-permission'>
                              <div className='admin-worker-manage-table__header-text'>
                                権限
                              </div>
                            </td>
                          </tr>
                        </thead>
                      </table>
                      <div
                        className='worker-manage-table-element'
                        id='worker-manage-right-side-table'
                        ref={this.refineTableRightSide}
                      >
                        <table className='table'>
                          <tbody>{this.AssignedWorkers()}</tbody>
                        </table>
                        <div className='blank-space' />
                      </div>
                    </div>
                    <div className='search-form__info search-form__info--right'>
                      <div className='search-form__info-text'>
                        <div className='dialog-admin-worker-manage__description'>
                          <div className='dialog-admin-worker-manage__description-content'>
                            <div className='dialog-admin-worker-manage__description-item'>
                              <span className='option-icon-circle option-icon-circle--chosei' />
                              <span className='option-icon-circle option-icon-circle--entrance' />
                              調整会議・入退場管理利用可
                            </div>
                            <div className='dialog-admin-worker-manage__description-item'>
                              <span className='option-icon-circle option-icon-circle--greenfile' />
                              労務安全利用可
                            </div>
                            <div className='dialog-admin-worker-manage__description-item'>
                              <BuildeeManagerIcon className={`icon--1_6x`} />
                              企業管理者
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='search-form__info-space' />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Information
            title={messageUtility.getMessage('I-000-195')}
            message={this.state.errorMessage}
            buttonText={messageUtility.getMessage('I-000-017')}
            visible={this.state.visibleDialogFlag}
            onClose={() => this.props.dialog.callback.close()} // BLDE_V2-41500: ユーザー登録ダイアログごと閉じる
            multilineText={true}
          />
          <div
            className='dialog__footer'
            style={{ height: 'auto', minHeight: 'auto' }}
          >
            <div className={alertStyle()}>
              {messageUtility.getMessage('E-001-003')}
            </div>
            <div className='dialog__footer--actions'>
              <button
                className='btn-fixedsize--sub'
                onClick={() => {
                  this.props.dialog.callback.back();
                }}
              >
                戻る
              </button>
              <span> </span>
              <button
                className='btn-fixedsize--effective'
                disabled={this.canNotSubmit()}
                onClick={this.submit}
              >
                追加
              </button>
              <button
                className={`btn-fixedsize--dialog-footer-right ${
                  this.state.addPartnerBoxDetailPermission
                    ? 'btn-fixedsize'
                    : 'btn-fixedsize--sub'
                }`}
                onClick={() => {
                  this.state.addPartnerBoxDetailPermission
                    ? this.props.dialog.callback.addUser()
                    : this.props.dialog.callback.requestRegister();
                }}
              >
                一覧にないユーザーを新規作成
              </button>
            </div>
          </div>
        </div>
        {this.state.isForemanWarningDialog && (
          <NotLoginForemanWarningDialog
            assignedWorker={this.state.assignedWorker}
            badUsers={this.state.badUsers}
            onClose={() => {
              this.setState({ isForemanWarningDialog: false });
            }}
            onExecute={() => {
              this.submitConnect();
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

/**
 * Tooltipで表示される文字
 * @param {string} data 表示データ
 */
const renderTooltipContent = data => {
  const rowStyle = {
    maxWidth: '240px',
    wordWrap: 'break-word',
    color: '#FFF',
    fontSize: '14px',
    lineHeight: '1.5',
    textAlign: 'left',
  };

  return (
    <React.Fragment>
      <div style={rowStyle}>{data}</div>
    </React.Fragment>
  );
};

/**
 * 協力会社ユーザーを検索して追加ダイアログの左側
 *
 * @class Worker
 * @extends {React.Component}
 */
class Worker extends React.Component {
  constructor(props) {
    super(props);
    this.uid = `worker_check_${_.uniqueId()}`;

    // 自社の会社ID
    this.myCompanyId = parseInt(SessionStorageService.getCompanyId(), 10);
  }

  /**
   * チェックボックスの選択
   *
   * @memberof Worker
   */
  selectRow = () => {
    this.refs.check.checked = !this.refs.check.checked;

    if (this.props.callback) {
      this.props.callback(this.props.data.id, this.refs.check.checked);
    }
  };

  /**
   * ユーザー種別
   */
  renderBuildeeManagerIcon = data => {
    let showBuildeeManagerIcon = false;
    if (
      _.has(data, 'permissions.buildee_manager_flg') &&
      data.permissions.buildee_manager_flg
    ) {
      showBuildeeManagerIcon = true;
    }
    if (showBuildeeManagerIcon) {
      return (
        <BuildeeManagerIcon
          className={`icon--2x admin-worker-manage-table__column-buildee-manager-icon`}
        />
      );
    }
    return null;
  };

  /**
   * @description サービスのアイコン設定
   * @param {object} permissions サービス権限
   */
  renderServiceIcons = permissions => {
    let icons = [];
    if (permissions) {
      // 調整会議
      if (permissions.use_chosei_flg) {
        icons.push(
          <span className='option-icon-circle option-icon-circle--chosei' />
        );
      } else {
        icons.push(
          <span className='option-icon-circle option-icon-circle--empty' />
        );
      }
      // 入退場
      if (permissions.use_nyutaijo_flg) {
        icons.push(
          <span className='option-icon-circle option-icon-circle--entrance' />
        );
      } else {
        icons.push(
          <span className='option-icon-circle option-icon-circle--empty' />
        );
      }
      // 労務安全
      if (permissions.use_green_file_flg) {
        icons.push(
          <span className='option-icon-circle option-icon-circle--greenfile' />
        );
      } else {
        icons.push(
          <span className='option-icon-circle option-icon-circle--empty' />
        );
      }
    }
    return _.map(icons, (icon, i) => (
      <React.Fragment key={`value-table__content-no.${i}`}>
        {icon}
      </React.Fragment>
    ));
  };

  render() {
    const { data } = this.props;
    return (
      <tr onClick={this.selectRow} className='table__item' key={this.uid}>
        <td className='value-table admin-worker-manage-table__column-checkbox'>
          <div>
            <div className='btn-checkbox-mini'>
              <label htmlFor={this.uid} className='checkbox'>
                <input
                  ref='check'
                  id={this.uid}
                  type='checkbox'
                  name={data.id}
                  checked={data.checked}
                />
                <i className='i-square i-2x' />
              </label>
            </div>
          </div>
        </td>
        <td className='value-table admin-worker-manage-table__column-branch'>
          <Tippy
            delay={[500, 0]}
            duration={10}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            html={renderTooltipContent(
              _.get(this.props, 'data.partner_company_branch.name', '本社')
            )}
          >
            <div className='admin-worker-manage-table__column-text'>
              {_.get(this.props, 'data.partner_company_branch.name', '本社')}
            </div>
          </Tippy>
        </td>
        <td className='value-table admin-worker-manage-table__column-user-type'>
          <div className='admin-worker-manage-table__column-text'>
            {roleIdToJapaneseRoleName(data.user_role_code)}
          </div>
        </td>
        <td className='value-table admin-worker-manage-table__column-name'>
          <Tippy
            delay={[500, 0]}
            duration={10}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            html={renderTooltipContent(data.fullname)}
          >
            <div className='admin-worker-manage-table__column-text'>
              {data.fullname}
            </div>
          </Tippy>
        </td>
        <td className='value-table admin-worker-manage-table__column-user-id'>
          <Tippy
            delay={[500, 0]}
            duration={10}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            role={`tippy_target_${data.login_id}`}
            html={renderTooltipContent(_.defaultTo(data.login_id, ''))}
          >
            <div className='admin-worker-manage-table__column-text '>
              {_.defaultTo(data.login_id, '')}
            </div>
          </Tippy>
        </td>
        <td className='value-table admin-worker-manage-table__column-permission'>
          <div className='admin-worker-manage-table__column-permission-items'>
            {this.renderServiceIcons(data.permissions)}
            {this.renderBuildeeManagerIcon(data)}
          </div>
        </td>
      </tr>
    );
  }
}

class AssignedWorker extends React.Component {
  constructor(props) {
    super(props);

    this.uid = `assign_worker_check_${_.uniqueId()}`;
    this.state = {
      id: props.data.id,
      jobs: props.data.jobs ? props.data.jobs : [],
      apiData: {
        field_id: parseInt(SessionStorageService.getItem('field_id'), 10),
        display_flag: 1,
      },
    };

    this.jumpToShowDropdown = this.jumpToShowDropdown.bind(this);
  }

  /**
   * チェックボックスの選択
   *
   * @memberof AssignedWorker
   */
  getValue = e => {
    this.refs.check.checked = !this.refs.check.checked;

    if (this.props.callback) {
      this.props.callback(this.props.data.id, this.refs.check.checked);
    }
  };

  /**
   * ユーザー種別
   */
  renderBuildeeManagerIcon = data => {
    let showBuildeeManagerIcon = false;
    if (
      _.has(data, 'permissions.buildee_manager_flg') &&
      data.permissions.buildee_manager_flg
    ) {
      showBuildeeManagerIcon = true;
    }
    if (showBuildeeManagerIcon) {
      return (
        <BuildeeManagerIcon
          className={`icon--2x admin-worker-manage-table__column-buildee-manager-icon`}
        />
      );
    }
    return null;
  };

  /**
   * @description サービスのアイコン設定
   * @param {object} permissions サービス権限
   */
  renderServiceIcons = permissions => {
    let icons = [];
    if (permissions) {
      // 調整会議
      if (permissions.use_chosei_flg) {
        icons.push(
          <span className='option-icon-circle option-icon-circle--chosei' />
        );
      } else {
        icons.push(
          <span className='option-icon-circle option-icon-circle--empty' />
        );
      }
      // 入退場
      if (permissions.use_nyutaijo_flg) {
        icons.push(
          <span className='option-icon-circle option-icon-circle--entrance' />
        );
      } else {
        icons.push(
          <span className='option-icon-circle option-icon-circle--empty' />
        );
      }
      // 労務安全
      if (permissions.use_green_file_flg) {
        icons.push(
          <span className='option-icon-circle option-icon-circle--greenfile' />
        );
      } else {
        icons.push(
          <span className='option-icon-circle option-icon-circle--empty' />
        );
      }
    }
    return _.map(icons, (icon, i) => (
      <React.Fragment key={`value-table__content-no.${i}`}>
        {icon}
      </React.Fragment>
    ));
  };

  /**
   * 職種のドロップダウンがクリックされたときチェックボックスがチェックされないようにする
   */
  handleDropDownClick = e => {
    e.stopPropagation();
  };

  jumpToShowDropdown = targetPosition => {
    // 右側のテーブルの位置を取得
    const tableRightSide = this.props.refineTableRightSide;
    const tablePosition = tableRightSide.getBoundingClientRect();

    tableRightSide.scrollBy(0, targetPosition.y - tablePosition.y);
  };

  render() {
    const { data } = this.props;
    const rightsideTableHeight = document.getElementById(
      'worker-manage-right-side-table'
    ).clientHeight;

    return (
      <tr onClick={this.getValue} className='table__item' key={this.uid}>
        <td className='value-table admin-worker-manage-table__column-checkbox'>
          <div>
            <div className='btn-checkbox-mini'>
              <label htmlFor={this.uid} className='checkbox'>
                <input
                  ref='check'
                  id={this.uid}
                  type='checkbox'
                  name={data.id}
                  checked={data.checked}
                />
                <i className='i-square i-2x' />
              </label>
            </div>
          </div>
        </td>
        <td className='value-table admin-worker-manage-table__column-branch'>
          <Tippy
            delay={[500, 0]}
            duration={10}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            html={renderTooltipContent(
              _.get(this.props, 'data.partner_company_branch.name', '本社')
            )}
          >
            <div className='admin-worker-manage-table__column-text'>
              {_.get(this.props, 'data.partner_company_branch.name', '本社')}
            </div>
          </Tippy>
        </td>
        <td className='value-table admin-worker-manage-table__column-job'>
          <div
            className='admin-worker-manage-table__column-text'
            style={{ display: 'none' }}
          >
            {roleIdToJapaneseRoleName(data.user_role_code)}
          </div>
          <div
            onClick={this.handleDropDownClick}
            className='admin-worker-manage-table__column-job-dropdown'
          >
            {/* 協力会社管理者ユーザーの場合、職種を登録しない為、プルダウンを非表示 */}
            {!isPartnerRoleId(data.user_role_code) && (
              <MultiSelectDropdownSaveOnClose
                className={'FieldTreeJobsDropdown'}
                selected={this.state.jobs}
                api={params => JobService.list(params)}
                apiParams={this.state.apiData}
                apiSearchKey='name'
                keyName='name'
                valueName='id'
                selectedValues={this.state.jobs}
                apiBindDataKey={'jobs'}
                scrollHeight={{ height: rightsideTableHeight - 120 }} // テーブルと職種ドロップダウンの縦長さの差分
                onSelect={values => {
                  this.setState({ jobs: values });
                  this.props.callbackJobs(this.state.id, values);
                }}
                jumpToShowDropdown={this.jumpToShowDropdown}
              />
            )}
          </div>
        </td>
        <td className='value-table admin-worker-manage-table__column-name'>
          <Tippy
            delay={[500, 0]}
            duration={10}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            html={renderTooltipContent(data.fullname)}
          >
            <div className='admin-worker-manage-table__column-text'>
              {data.fullname}
            </div>
          </Tippy>
        </td>
        <td className='value-table admin-worker-manage-table__column-user-id'>
          <Tippy
            delay={[500, 0]}
            duration={10}
            arrow={true}
            arrowType='sharp'
            placement='bottom'
            role={`tippy_target_${data.login_id}`}
            html={renderTooltipContent(_.defaultTo(data.login_id, ''))}
          >
            <div className='admin-worker-manage-table__column-text '>
              {_.defaultTo(data.login_id, '')}
            </div>
          </Tippy>
        </td>
        <td className='value-table admin-worker-manage-table__column-permission'>
          <div className='admin-worker-manage-table__column-permission-items'>
            {this.renderServiceIcons(data.permissions)}
            {this.renderBuildeeManagerIcon(data)}
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FieldTreeAdminWorkerManager.jsx